import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Partnership from "@/pages/Partnership";
import ConsumerGoods from "@/pages/ConsumerGoods";
import About from "@/pages/About";
import { setLenis, getLenis } from "@/lib/lenis";

const TITLES = {
  "/": "Ananya Refresh — Packaged Water & Snacks",
  "/products": "Products — Ananya Refresh",
  "/partnership": "Become a Distributor — Ananya Refresh",
  "/consumer-goods": "About Ananya Consumer Goods Pvt. Ltd.",
  "/about": "Our Story — Ananya Refresh",
};

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = TITLES[pathname] || "Ananya Refresh";
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App bg-navy min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <ScrollManager />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/partnership" element={<Partnership />} />
            <Route path="/consumer-goods" element={<ConsumerGoods />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <WhatsAppButton />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
